import { useEffect, useRef } from "react"
import { BaseTable, ErrorText, TableHeader } from "components"
import { Job, Tax } from "../../components"
import { ErrorMessage } from "@hookform/error-message"
import { useFormContext } from "react-hook-form"
import { BillServiceValues } from "../types"
import { TableFormBody } from "./TableFormBody"

type BillServiceTableFormProps = {
  disable?: boolean
}

export const BillServiceTableForm = ({ disable }: BillServiceTableFormProps) => {
  const ref = useRef<HTMLTableElement>(null)
  const { formState: { errors } } = useFormContext<BillServiceValues>()

  useEffect(() => {
    if (errors["details"]) ref.current?.scrollIntoView()

    const additionalHeight = 150
    const scrolledY = window.scrollY

    if (scrolledY) window.scroll(0, scrolledY - additionalHeight)

    // eslint-disable-next-line
  }, [errors])

  return (
    <div className="overflow-x-auto">
      <div ref={ref} className={errors["details"] ? "border border-error" : ""}>
        <BaseTable>
          <TableHeader>
            <tr>
              <th>#</th>
              <th>ACCOUNT</th>
              <th>ACCOUNT NAME</th>
              <th>LINE NOTE DESCRIPTION</th>
              <th>QTY</th>
              <th>UNIT</th>
              <th>PRICE</th>
              <th>DISC</th>
              <th>TOTAL</th>
              <Job />
              <Tax />
              {!disable && <th>ACTION</th>}
            </tr>
          </TableHeader>
          <tbody>
            <TableFormBody disable={disable} />
          </tbody>
        </BaseTable>
      </div>

      <ErrorMessage
        name="details"
        errors={errors}
        render={({ message }) => <ErrorText text={message} />}
      />
    </div>
  )
}